import { ifDefined, withDefault } from "@faedev/editor-utils";
import translations from "src/translations.json";

function translate(key: string, lang: string) {
  return ifDefined(
    translations[key],
    (value) => withDefault(value[lang], key),
    () => key
  );
}

export default translate;
